var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "photo_camera_FILL1_wght400_GRAD0_opsz48",
    d: "M19,27.525a6.276,6.276,0,0,0,6.375-6.375A6.246,6.246,0,0,0,19,14.775a6.217,6.217,0,0,0-6.375,6.375A6.246,6.246,0,0,0,19,27.525ZM6.25,33a2.159,2.159,0,0,1-1.575-.675A2.159,2.159,0,0,1,4,30.75V11.513a2.18,2.18,0,0,1,.675-1.556A2.131,2.131,0,0,1,6.25,9.263h5.512L14.5,6h9l2.738,3.262H31.75a2.152,2.152,0,0,1,1.556.694A2.152,2.152,0,0,1,34,11.513V30.75a2.131,2.131,0,0,1-.694,1.575A2.18,2.18,0,0,1,31.75,33Z",
    transform: "translate(-4 -6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.f0c9098bee749db62111e5a748c085f3.svg";
export { ForwardRef as ReactComponent };